import {
  refreshUser,
  initUserStore,
  startTokenRefreshScheduler,
  stopTokenRefreshScheduler,
} from '@tshared/stores/user.store'
import { useEffect, useState } from 'react'

import { useOrganizationQuery } from '@/apis/organization.api.ts'
import App from '@/containers/App.tsx'

export default function Root() {
  const [ready, setReady] = useState(false)
  const organizationQuery = useOrganizationQuery()

  useEffect(() => {
    let mounted = true

    void initUserStore()
      .then(() => refreshUser())
      .finally(() => {
        if (!mounted) return

        startTokenRefreshScheduler()
        setReady(true)
      })

    return () => {
      mounted = false
      stopTokenRefreshScheduler()
    }
  }, [])

  if (!ready || organizationQuery.isLoading || organizationQuery.isError) return null

  return <App />
}
